<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <persona-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import PersonaCrud from "./PersonaCrud";
    export default {
        name: "Persona",
        components: {PersonaCrud}
    }
</script>

<style scoped>

</style>

